export class ForbiddenException implements Error {
    public name = 'Forbidden Exception'
    public message = 'HTTP Request failed with 403 forbidden!'
}
